/**
 * ★ VX (decisão do dono, 20/set/2026) — a FICHA ÚNICA do lead, na ordem do trabalho.
 *
 * Três fases, cada uma com cor fixa (variável CSS) e a seção da etapa ATUAL com a borda
 * mais forte. É a mesma ficha no funil, na lista e no chat. Puro: quem renderiza é
 * `components/leads/FichaLead.jsx`.
 */
export const FASES = [
  { id: 'captacao', label: 'Captação — SDR', cor: 'var(--fase-captacao)' },
  { id: 'agenda', label: 'Agendamento e comparecimento', cor: 'var(--fase-agenda)' },
  { id: 'fechamento', label: 'Negociação e fechamento — negociador', cor: 'var(--fase-fechamento)' },
];

export const SECAO_PADRAO = 'captacao';

/**
 * Mapa etapa → fase (aprovado pelo dono): as sete etapas vivas e as quatro antigas,
 * que só se leem. Desconhecida/vazia → captação.
 */
const FASE_POR_ETAPA = {
  novo: 'captacao', em_contato: 'captacao', qualificado: 'captacao',
  nao_agendou: 'agenda', agendado: 'agenda', nao_compareceu: 'agenda',
  compareceu: 'fechamento', nao_fechou: 'fechamento', fechado: 'fechamento', em_negociacao: 'fechamento', perdido: 'fechamento',
};

export const secaoDaEtapa = (etapa) => FASE_POR_ETAPA[etapa] ?? SECAO_PADRAO;

export const fasePorId = (id) => FASES.find((f) => f.id === id) ?? FASES[0];
